(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Components/Popover", [], factory);
	else if(typeof exports === 'object')
		exports["Components/Popover"] = factory();
	else
		root["NextcloudVue"] = root["NextcloudVue"] || {}, root["NextcloudVue"]["Components/Popover"] = factory();
})(window, function() {
return 